import Grid from './Grid';
import Tower from './Tower';
import List from './List';

const templates = {
    Grid,
    List,
    Tower
};

export default templates;
